import React, { useState, useEffect } from 'react';
import { Card } from '../../../components/ui/Card';
import { Toggle } from '../../../components/ui/Toggle';
import { Radio } from '../../../components/ui/Radio';
import { Button } from '../../../components/ui/Button';
import { useSettings } from '../../../hooks/useSettings';

export function NotificationSettings() {
  const { settings, loading, updateSettings } = useSettings();
  const [emailNotifications, setEmailNotifications] = useState({
    newEntries: false,
    entryValidation: false,
    bankReconciliation: false,
    taxDeadlines: false,
    treasuryAlerts: false
  });

  const [notificationPreference, setNotificationPreference] = useState('realtime');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (settings?.notifications) {
      setEmailNotifications({
        newEntries: settings.notifications.journal_validation?.email || false,
        entryValidation: settings.notifications.journal_validation?.email || false,
        bankReconciliation: settings.notifications.report_generation?.email || false,
        taxDeadlines: settings.notifications.fiscal_year_closing?.email || false,
        treasuryAlerts: settings.notifications.system_alerts?.email || false
      });
    }
  }, [settings]);

  const handleEmailNotificationChange = (key: keyof typeof emailNotifications) => (checked: boolean) => {
    setEmailNotifications(prev => ({ ...prev, [key]: checked }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      await updateSettings({
        category: 'notifications',
        settings: {
          journal_validation: { 
            email: emailNotifications.entryValidation, 
            browser: true 
          },
          report_generation: { 
            email: emailNotifications.bankReconciliation, 
            browser: true 
          },
          user_mention: { 
            email: true, 
            browser: true 
          },
          system_alerts: { 
            email: emailNotifications.treasuryAlerts, 
            browser: true 
          },
          fiscal_year_closing: { 
            email: emailNotifications.taxDeadlines, 
            browser: true 
          }
        }
      });
      alert('Préférences de notification enregistrées avec succès');
    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <Card title="Notifications">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-4">
            <h3 className="text-sm font-medium text-gray-900">Notifications par email</h3>
            <div className="space-y-2">
              <Toggle
                label="Nouvelles écritures comptables"
                checked={emailNotifications.newEntries}
                onChange={handleEmailNotificationChange('newEntries')}
              />
              <Toggle
                label="Validation des écritures"
                checked={emailNotifications.entryValidation}
                onChange={handleEmailNotificationChange('entryValidation')}
              />
              <Toggle
                label="Rapprochements bancaires"
                checked={emailNotifications.bankReconciliation}
                onChange={handleEmailNotificationChange('bankReconciliation')}
              />
              <Toggle
                label="Échéances fiscales"
                checked={emailNotifications.taxDeadlines}
                onChange={handleEmailNotificationChange('taxDeadlines')}
              />
              <Toggle
                label="Alertes de trésorerie"
                checked={emailNotifications.treasuryAlerts}
                onChange={handleEmailNotificationChange('treasuryAlerts')}
              />
            </div>

            <h3 className="text-sm font-medium text-gray-900 pt-4">Préférences de notification</h3>
            <div className="space-y-2">
              <Radio
                name="notification-preference"
                label="Temps réel"
                value="realtime"
                checked={notificationPreference === 'realtime'}
                onChange={(e) => setNotificationPreference(e.target.value)}
              />
              <Radio
                name="notification-preference"
                label="Résumé quotidien"
                value="daily"
                checked={notificationPreference === 'daily'}
                onChange={(e) => setNotificationPreference(e.target.value)}
              />
              <Radio
                name="notification-preference"
                label="Résumé hebdomadaire"
                value="weekly"
                checked={notificationPreference === 'weekly'}
                onChange={(e) => setNotificationPreference(e.target.value)}
              />
            </div>
          </div>

          <div className="flex justify-end">
            <Button type="submit" disabled={isSaving || loading}>
              {isSaving ? 'Enregistrement...' : 'Enregistrer les préférences'}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
}